module.exports = __webpack_public_path__ + "static/media/personal_trainer.28c35b26.svg";